import Swal from 'sweetalert2'

export function showLotteryRoundClosedAlert(
  roundDisplay: string,
  redirectLabel: string,
  onRedirect: () => void,
): void {
  let count = 5
  Swal.fire({
    icon: 'warning',
    title: `${roundDisplay} ถูกปิดรับแทงแล้ว`,
    html: `กรุณาเลือกรอบอื่น<br><strong id="round-closed-countdown">จะกลับไป${redirectLabel} ใน ${count} วินาที</strong>`,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
  }).then(() => {
    onRedirect()
  })

  const interval = window.setInterval(() => {
    count -= 1
    const el = document.getElementById('round-closed-countdown')
    if (el) {
      el.textContent =
        count > 0 ? `จะกลับไป${redirectLabel} ใน ${count} วินาที` : 'กำลัง redirect...'
    }
    if (count <= 0) window.clearInterval(interval)
  }, 1000)
}
